import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class AlertService {
  private options: Partial<IndividualConfig> = {
    timeOut: 5000,
    extendedTimeOut: 2000,
    progressBar: false,
    disableTimeOut: false,
  };

  private httpErrorOptions: Partial<IndividualConfig> = {
    timeOut: 25_000,
    extendedTimeOut: 2000,
    progressBar: false,
    disableTimeOut: true,
    closeButton: true,
  };

  constructor(private toastService: ToastrService) {}

  success(title?: string, detail?: string): void {
    this.toastService.success(detail, title, this.options);
  }

  warning(title?: string, detail?: string, disableTimeOut = false): void {
    const overrideOptions = {
      ...this.options,
      disableTimeOut,
    };
    this.toastService.warning(detail, title, overrideOptions);
  }

  info(title?: string, detail?: string): void {
    this.toastService.info(detail, title, this.options);
  }

  error(
    title?: HttpErrorResponse | string | TypeError,
    detail?: string,
    isError?: boolean,
  ) {
    if (title instanceof HttpErrorResponse) {
      const e = title;

      if (
        (e.error?.errors?.length && e.error?.errors?.length > 0) ||
        (e.error?.errors && Object.keys(e.error?.errors as object).length > 0)
      ) {
        if (typeof e.error.errors.map === 'function') {
          const eList = e.error.errors
            .map((e: { message: string }) => {
              return e.message;
            })
            .join('\r\n');
          this.toastService.error(
            eList as string,
            e.statusText,
            this.httpErrorOptions,
          );
        } else {
          const eList = Object.keys(e.error.errors as object)
            .flatMap((x) => {
              return e.error.errors[x] as string[];
            })
            .join('\r\n');
          this.toastService.error(eList, e.statusText, this.httpErrorOptions);
        }
      } else {
        this.toastService.error(
          (e.error ?? e.message) as string,
          e.statusText,
          this.httpErrorOptions,
        );
      }
    } else if (title instanceof TypeError) {
      const e = title;
      this.toastService.error(e.message, e.name, this.httpErrorOptions);
    } else {
      this.toastService.error(
        detail,
        title,
        isError ? this.httpErrorOptions : this.options,
      );
    }
  }
}
